"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var isObject = function isObject(obj) {
  return (0, _typeof2["default"])(obj) === 'object' && obj !== null;
};

var _default = isObject;
exports["default"] = _default;